/**
 * TonnieCheckedBadge (Feature-Flagged Wrapper)
 *
 * Wraps @tonnie/ui's TonnieCheckedBadge with the ENABLE_TONNIE_CHECKED feature flag.
 * When the flag is off, renders nothing.
 *
 * Usage: Replace imports from '@tonnie/ui' with this module.
 */

import {
  TonnieCheckedBadge as BaseTonnieCheckedBadge,
  type TonnieCheckedBadgeProps,
} from '@tonnie/ui';

import { featureFlags } from '@/core/config/feature-flags';

export type { TonnieCheckedBadgeProps };

export function TonnieCheckedBadge(props: TonnieCheckedBadgeProps) {
  if (!featureFlags.ENABLE_TONNIE_CHECKED) return null;
  return <BaseTonnieCheckedBadge {...props} />;
}
